<template>
        <div id="payer-contract-association-modal" class="modal fade" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Associate Payers with Contract</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div id="modalBody" class="modal-body">
                        <div v-if="contract" class="mx-1">
                            <div><span class="font-weight-bold">Contract:</span> {{ contract.description }}</div>
                            <div class="d-flex">
                                <div><span class="font-weight-bold">Rate:</span> {{ contract.rate }}%</div>
                                <div v-if="contract.activated_at" class="ml-3">
                                    <span class="font-weight-bold">Activated:</span> {{ contract.activated_at | localizeTime('YYYY-MM-DD HH:mm:ss') }}
                                </div>
                                <div v-if="contract.terminated_at" class="ml-3">
                                    <span class="font-weight-bold">Terminated:</span> {{ contract.terminated_at | localizeTime('YYYY-MM-DD HH:mm:ss') }}
                                </div>
                            </div>                            
                        </div>
                        <div class="mt-2 px-3  border-top">
                            <div class="input-group input-group-sm mt-3">
                                <div class="input-group-prepend">
                                    <div class="input-group-text"><i class="fas fa-search fa-sm text-muted"></i></div>
                                </div>
                                <input type="text" class="form-control" placeholder="Search by Payer Name" v-model="searchString">
                            </div>
                        </div>
                        <div class="row mt-3 mx-1">
                            <div class="col mr-2">
                                <h5>Available Payers</h5>
                            </div>
                            <div class="col ml-2">
                                <h5>Associated Payers</h5>
                            </div>                            
                        </div>
                        <div class="row mx-1">
                            <div class="col bg-light p-3 mr-2" @drop="onDrop($event, null)" @dragover.prevent @dragenter.prevent>
                                <div v-for="payer in available" :key="'available-payer-' + payer.id" class="shadow-sm p-3 mb-2 bg-white rounded" draggable @dragstart="startDrag($event, payer)">
                                    <div class="font-weight-bold">{{ payer.name }}</div>
                                    <div class="font-sm">{{ payer.address }} {{ payer.city }}, {{ payer.state }} {{ payer.postal_code }}</div>
                                    <div class="font-sm">Tel: {{ payer.phone_number | telephone }}</div>
                                    <div class="font-sm">Fax: {{ payer.fax_number | telephone }}</div>
                                </div>
                            </div>
                            <div class="col bg-light p-3 ml-2" @drop="onDrop($event, contract.id)" @dragover.prevent @dragenter.prevent>
                                <div v-for="payer in associated" :key="'associated-payer-' + payer.id" class="shadow-sm p-3 mb-2 bg-white rounded" draggable @dragstart="startDrag($event, payer)">
                                    <div class="font-weight-bold">{{ payer.name }}</div>
                                    <div class="font-sm">{{ payer.address }} {{ payer.city }}, {{ payer.state }} {{ payer.postal_code }}</div>
                                    <div class="font-sm">Tel: {{ payer.phone_number | telephone }}</div>
                                    <div class="font-sm">Fax: {{ payer.fax_number | telephone }}</div>
                                </div>
                            </div>
                        </div>                      
                    </div>
                    <div class="modal-footer">
                        <button id="button-accept" type="button" class="btn btn-primary" @click="associate()">Associate</button>
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                    </div>
                </div>
            </div>
        </div>    
</template>

<script>
export default {
    data() {
        return {
            contract: null,
            payers: [],
            searchString: ''
        }
    },
    computed: {
        available: function () {
            return this.payers.filter((payer) => ((!payer.client_payer_contract_id) && payer.name.toLowerCase().indexOf(this.searchString.toLowerCase()) !== -1));
        },
        associated: function () {
            return this.payers.filter((payer) => ((payer.client_payer_contract_id && this.contract && (payer.client_payer_contract_id == this.contract.id)) && payer.name.toLowerCase().indexOf(this.searchString.toLowerCase()) !== -1));
        }        
    },
    methods: {
        show: function (contract) {
            this.contract = contract;
            
            axios.get(`/ajax/provider/clients/${this.contract.client_id}/payercontracts/${this.contract.id}/payers`)
                .then(response => {

                    this.payers = response.data.payers;
                    $('#payer-contract-association-modal').modal('show');
                })
                .catch(error => {
                    toastr['error'](error.response.data, 'ERROR', {timeOut: 10000, positionClass: "toast-top-full-width", closeButton: true});
                });
        },
        startDrag: function (e, item) {
            e.dataTransfer.dropEffect = 'move';
            e.dataTransfer.effectAllowed = 'move';
            e.dataTransfer.setData('id', item.id);
        },
        onDrop: function (e, value) {
            const id = e.dataTransfer.getData('id');
            const item = this.payers.find((item) => item.id == id);
            item.client_payer_contract_id = value;
        },
        associate: function () {
            axios.patch(`/ajax/provider/clients/${this.contract.client_id}/payercontracts/${this.contract.id}/payers/associate`, {
                payers: this.payers
            })
            .then(response => {
                $('#payer-contract-association-modal').modal('hide');
            })
            .catch(error => {

            });
        }
    },
    created() {      

        eventHub.$on('show-associate-payer-contract', this.show);
    },
    beforeDestroy() {

        eventHub.$off('show-associate-payer-contract');
    }    
}
</script>

<style scoped>
    .font-sm {
        font-size: 0.80em;
        line-height: 1.1;
    }
</style>